var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPointsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrows-to-dot-solid_1_",
    "data-name": "arrows-to-dot-solid (1)",
    d: "M11,0a1.373,1.373,0,0,1,1.375,1.375V2.749h1.375a1.378,1.378,0,0,1,.975,2.35L11.973,7.849a1.377,1.377,0,0,1-1.946,0L7.277,5.1a1.378,1.378,0,0,1,.975-2.35H9.627V1.375A1.373,1.373,0,0,1,11,0ZM7.277,16.9l2.749-2.749a1.377,1.377,0,0,1,1.946,0L14.723,16.9a1.378,1.378,0,0,1-.975,2.35H12.373v1.375a1.375,1.375,0,0,1-2.749,0V19.246H8.248a1.378,1.378,0,0,1-.975-2.35Zm-5.9-7.277H2.749V8.248A1.378,1.378,0,0,1,5.1,7.273l2.749,2.749a1.377,1.377,0,0,1,0,1.946L5.1,14.718a1.378,1.378,0,0,1-2.35-.975v-1.37H1.375a1.375,1.375,0,1,1,0-2.749Zm12.776,2.346a1.377,1.377,0,0,1,0-1.946L16.9,7.273a1.378,1.378,0,0,1,2.35.975V9.623h1.375a1.375,1.375,0,0,1,0,2.749H19.246v1.375a1.378,1.378,0,0,1-2.35.975l-2.749-2.749ZM11,9.623A1.375,1.375,0,1,1,9.623,11,1.375,1.375,0,0,1,11,9.623Z",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsIcon);
export default __webpack_public_path__ + "static/media/points-icon.91295b17647430d427886d59729f32f3.svg";
export { ForwardRef as ReactComponent };